/* src/app/components/controls/sem-date-picker/sem-date-picker.component.css */
mat-datepicker-toggle {
  display: block;
  position: absolute;
  right: -5px;
  top: 15px;
}
::ng-deep mat-datepicker-toggle svg path {
  display: none;
}
/*# sourceMappingURL=sem-date-picker.component.css.map */
